/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createMembership } from '../fn/memberships/create-membership';
import { CreateMembership$Params } from '../fn/memberships/create-membership';
import { deleteMembership } from '../fn/memberships/delete-membership';
import { DeleteMembership$Params } from '../fn/memberships/delete-membership';
import { getMembership } from '../fn/memberships/get-membership';
import { GetMembership$Params } from '../fn/memberships/get-membership';
import { GroupMembershipDtoPage } from '../models/group-membership-dto-page';
import { listGroupMemberships } from '../fn/memberships/list-group-memberships';
import { ListGroupMemberships$Params } from '../fn/memberships/list-group-memberships';
import { listMemberships } from '../fn/memberships/list-memberships';
import { ListMemberships$Params } from '../fn/memberships/list-memberships';
import { listUserMemberships } from '../fn/memberships/list-user-memberships';
import { ListUserMemberships$Params } from '../fn/memberships/list-user-memberships';
import { MembershipDto } from '../models/membership-dto';
import { MembershipDtoPage } from '../models/membership-dto-page';
import { UserMembershipDtoPage } from '../models/user-membership-dto-page';

@Injectable({ providedIn: 'root' })
export class MembershipsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listMemberships()` */
  static readonly ListMembershipsPath = '/v0/memberships';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listMemberships()` instead.
   *
   * This method doesn't expect any request body.
   */
  listMemberships$Response(params?: ListMemberships$Params, context?: HttpContext): Observable<StrictHttpResponse<MembershipDtoPage>> {
    return listMemberships(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listMemberships$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listMemberships(params?: ListMemberships$Params, context?: HttpContext): Observable<MembershipDtoPage> {
    return this.listMemberships$Response(params, context).pipe(
      map((r: StrictHttpResponse<MembershipDtoPage>): MembershipDtoPage => r.body)
    );
  }

  /** Path part for operation `listGroupMemberships()` */
  static readonly ListGroupMembershipsPath = '/v0/memberships/groups';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listGroupMemberships()` instead.
   *
   * This method doesn't expect any request body.
   */
  listGroupMemberships$Response(params: ListGroupMemberships$Params, context?: HttpContext): Observable<StrictHttpResponse<GroupMembershipDtoPage>> {
    return listGroupMemberships(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listGroupMemberships$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listGroupMemberships(params: ListGroupMemberships$Params, context?: HttpContext): Observable<GroupMembershipDtoPage> {
    return this.listGroupMemberships$Response(params, context).pipe(
      map((r: StrictHttpResponse<GroupMembershipDtoPage>): GroupMembershipDtoPage => r.body)
    );
  }

  /** Path part for operation `listUserMemberships()` */
  static readonly ListUserMembershipsPath = '/v0/memberships/users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listUserMemberships()` instead.
   *
   * This method doesn't expect any request body.
   */
  listUserMemberships$Response(params: ListUserMemberships$Params, context?: HttpContext): Observable<StrictHttpResponse<UserMembershipDtoPage>> {
    return listUserMemberships(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listUserMemberships$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listUserMemberships(params: ListUserMemberships$Params, context?: HttpContext): Observable<UserMembershipDtoPage> {
    return this.listUserMemberships$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserMembershipDtoPage>): UserMembershipDtoPage => r.body)
    );
  }

  /** Path part for operation `getMembership()` */
  static readonly GetMembershipPath = '/v0/memberships/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMembership()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMembership$Response(params: GetMembership$Params, context?: HttpContext): Observable<StrictHttpResponse<MembershipDto>> {
    return getMembership(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMembership$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMembership(params: GetMembership$Params, context?: HttpContext): Observable<MembershipDto> {
    return this.getMembership$Response(params, context).pipe(
      map((r: StrictHttpResponse<MembershipDto>): MembershipDto => r.body)
    );
  }

  /** Path part for operation `createMembership()` */
  static readonly CreateMembershipPath = '/v0/memberships/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createMembership()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createMembership$Response(params: CreateMembership$Params, context?: HttpContext): Observable<StrictHttpResponse<MembershipDto>> {
    return createMembership(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createMembership$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createMembership(params: CreateMembership$Params, context?: HttpContext): Observable<MembershipDto> {
    return this.createMembership$Response(params, context).pipe(
      map((r: StrictHttpResponse<MembershipDto>): MembershipDto => r.body)
    );
  }

  /** Path part for operation `deleteMembership()` */
  static readonly DeleteMembershipPath = '/v0/memberships/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteMembership()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMembership$Response(params: DeleteMembership$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteMembership(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteMembership$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMembership(params: DeleteMembership$Params, context?: HttpContext): Observable<void> {
    return this.deleteMembership$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
